import punycode from 'punycode';
import * as React from 'react';
import { mapTags } from '@gandi/translate';
import { Base, Text } from '@gandi/ui';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const mailboxProducts = ['mailbox', 'mailboxv2'];
const productTypesConsolidate = {
  sites: 'domains',
  mailbox: 'domains',
  mailboxv2: 'domains',
  domain_option: 'domains',
  phone_advisory: 'services',
  tmch: 'services'
};
export const productTypeApps = {
  domains: 'domain',
  certificates: 'certificate',
  paas: 'simplehosting',
  webhostingCreation: 'simplehosting',
  webhostingRenewal: 'simplehosting',
  webhostingUpdate: 'simplehosting',
  iaas: 'cloud',
  services: 'services',
  oneClickCreation: 'simplehosting',
  oneClickRenewal: 'simplehosting'
};
export const getItemType = item => {
  if (item.product_type === 'paas') {
    if (item.details?.appnames?.includes('wordpress')) {
      if (item.action_name === 'create') {
        return 'oneClickCreation';
      }
      return 'oneClickRenewal';
    }
    if (item.details?.product_uuid) {
      if (item.action_name === 'create') {
        return 'webhostingCreation';
      }
      if (item.action_name === 'renew') {
        return 'webhostingRenewal';
      }
      return 'webhostingUpdate';
    }
  }
  // $FlowFixMe[invalid-computed-prop]
  return productTypesConsolidate[item.product_type] || item.product_type;
};
export const getItemTitle = ({
  item,
  href
}, translator) => {
  if (mailboxProducts.indexOf(item.product_type) > -1) {
    return translator.__('%(count)s Mailboxes', {
      count: item.quantity
    });
  }
  if (item.product_type === 'iaas') {
    return translator.__('Cloud Balance Credit');
  }
  if (item.product_type === 'paas' && !!item.details?.appnames?.length) {
    if (href) {
      return mapTags(translator.__('Web hosting: [[appNamesLink:]]'), () => ({
        appNamesLink: /*#__PURE__*/_jsx("a", {
          href: href,
          children: item.details?.appnames?.join(', ')
        })
      }));
    }
    return translator.__('Web hosting: %(name)s', {
      name: item.details.appnames.join(', ')
    });
  }
  if (item.name && item.name_label.indexOf(item.name) > -1) {
    // $FlowFixMe[incompatible-call]
    return item.name_label.replace(item.name, punycode.toUnicode(item.name));
  }
  return item.name_label;
};
export const getItemSubtitle = ({
  item
}, translator, showDNSTrialText) => {
  if (item.product_type === 'paas') {
    if (item.details) {
      if (item.details.vhost) {
        return translator.__('With %(fqdn)s', {
          fqdn: item.details.vhost
        });
      }
      return item.details.product_uuid ? '' : translator.__('Web Hosting Pack Create');
    }
    if (item.action_name === 'create') {
      return translator.__('Simple Hosting Create');
    }
    if (item.action_name === 'renew') {
      return translator.__('Simple Hosting Renew');
    }
    if (item.action_name === 'add') {
      return translator.__('Simple Hosting Update');
    }
  }
  if (mailboxProducts.indexOf(item.product_type) > -1 || item.product_type === 'mailbox-standalone') {
    if (item.action_name === 'create') {
      return translator.__('Mailbox Creation');
    }
    if (item.action_name === 'renew') {
      return translator.__('Mailbox Renew');
    }
  }
  if (item.product_type === 'domains') {
    if (item.action_name === 'create') {
      return translator.__('Domain Create');
    }
    if (item.action_name === 'renew') {
      return translator.__('Domain Renew');
    }
    if (item.action_name === 'transfer') {
      return translator.__('Domain Transfer');
    }
  }
  if (item.product_type === 'iaas') {
    return translator.__('Cloud | Extend expiration date');
  }
  if (item.product_type === 'sites') {
    if (item.action_name === 'create') {
      return translator.__('Marketplace Go Sitebuilder Create');
    }
    if (item.action_name === 'renew') {
      return translator.__('Marketplace Go Sitebuilder Renew');
    }
  }
  if (item.product_type === 'phone_advisory') {
    return translator.__('Purchase');
  }
  if (item.product_type === 'tmch') {
    if (item.action_name === 'create') {
      return translator.__('Registration');
    }
    if (item.action_name === 'renew') {
      return translator.__('Renew');
    }
  }
  if (item.product_type === 'domain_option') {
    if (item.name === 'premium_dns' && showDNSTrialText) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Base, {
          tagName: "p",
          marginY: "none",
          children: translator.__('After the 18th of June, £2.99 excl. VAT per month.')
        }), /*#__PURE__*/_jsx(Text, {
          children: translator.__('Commitment-free offer - Cancel anytime.')
        })]
      });
    }
  }
  return item.product_type_label;
};